import type TeamState from "./state";

export type State = ReturnType<typeof TeamState>;

export enum DurationFilter {
    ALL = 'All',
    WEEK = '7D',
    MONTH = '1M',
    YEAR = '1Y',
}